import type { PhotoDim } from "@/data/schools";

const GRADIENTS: Record<PhotoDim, [string, string, string]> = {
  city: ["#A7CCDC", "#5A9FBD", "#2E6E8E"],
  interior: ["#FFDEC2", "#FFB789", "#E08756"],
  map: ["#C9EFDB", "#7DC7A6", "#34926C"],
  floor: ["#FFF1CC", "#F2D688", "#BB983F"],
  coral: ["#FFCFC4", "#FF8A78", "#EC4B36"],
  sky: ["#D5EBFF", "#82B8F0", "#3A78C6"],
  night: ["#CFE4DA", "#7BAD96", "#2E6E58"],
};

export type PhotoProps = {
  label?: string;
  height?: number;
  dim?: PhotoDim;
  className?: string;
  rounded?: boolean;
};

export function Photo({
  label,
  height = 180,
  dim = "city",
  className = "",
  rounded = true,
}: PhotoProps) {
  const [a, b, c] = GRADIENTS[dim];
  return (
    <div
      className={`relative overflow-hidden ${rounded ? "rounded-xl" : ""} ${className}`}
      style={{
        height,
        background: `radial-gradient(120% 90% at 25% 10%, ${a} 0%, ${b} 50%, ${c} 100%)`,
      }}
    >
      {label ? (
        <span className="absolute bottom-3 left-3 rounded-md bg-black/20 px-2 py-1 text-[10px] font-medium text-white/90 backdrop-blur-sm">
          {label}
        </span>
      ) : null}
    </div>
  );
}
